module.exports = __webpack_public_path__ + "img/icon-sports-white.bfc75d22.svg";